import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore, { history } from 'store/configureStore'
import App from 'src/App'
import Auth0ProviderWrapper from 'src/providers/Auth0ProviderWrapper'
import { ConnectedRouter } from 'connected-react-router'
import { auth0Settings, LD_CREDS } from 'lib/config'
import { FlagsProvider, FlagsSingleton } from 'flags'
import flagsAppLevelSubscribes from '../config/flagsAppLevelSubscribes'
import flagsLocalDevFlagOverride from '../config/flagsLocalDevFlagOverride'

import initAppInsights from 'lib/appInsights'

// const appInsights = initAppInsights(history)

const store = configureStore()
const render = async () => {
  FlagsSingleton.initialize({
    clientOptions: {
      user: LD_CREDS.user,
      options: {
        application: {
          id: 'secondstep-app',
        },
      },
      clientID: LD_CREDS.clientSideId,
    },
    appLevelSubscribedFlags: flagsAppLevelSubscribes,
    localDevFlagOverride: flagsLocalDevFlagOverride,
    restrictFlagEvaluationsToAppLevelSubscribedFlags: true,
  })
  await FlagsSingleton.waitForFlagSystemReady()

  ReactDOM.render(
    <FlagsProvider softReload={true}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Auth0ProviderWrapper {...auth0Settings} history={history}>
            <App />
          </Auth0ProviderWrapper>
        </ConnectedRouter>
      </Provider>
    </FlagsProvider>,

    document.getElementById('root'),
  )
}

render()
